import { TableProps } from "@nextui-org/react";

export const tableStyle: TableProps = {
  bordered: true,
  borderWeight: "light",
  children: [], // fixes type error
}
